/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectResource } from './';
import {
    ProjectResourceFromJSON,
    ProjectResourceFromJSONTyped,
    ProjectResourceToJSON,
} from './';
import type { ProposalResource } from './';
import {
    ProposalResourceFromJSON,
    ProposalResourceFromJSONTyped,
    ProposalResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OpportunitiesResource
 */
export interface OpportunitiesResource {
    /**
     * 
     * @type {boolean}
     * @memberof OpportunitiesResource
     */
    isNewCommercialRelation?: boolean;
    /**
     * The list of proposal waiting for a quote
     * @type {Array<ProposalResource>}
     * @memberof OpportunitiesResource
     */
    proposals: Array<ProposalResource>;
    /**
     * The list of renewable projects
     * @type {Array<ProjectResource>}
     * @memberof OpportunitiesResource
     */
    projects: Array<ProjectResource>;
}

/**
 * Check if a given object implements the OpportunitiesResource interface.
 */
export function instanceOfOpportunitiesResource(value: object): value is OpportunitiesResource {
    if (!('proposals' in value) || value['proposals'] === undefined) return false;
    if (!('projects' in value) || value['projects'] === undefined) return false;
    return true;
}

export function OpportunitiesResourceFromJSON(json: any): OpportunitiesResource {
    return OpportunitiesResourceFromJSONTyped(json, false);
}

export function OpportunitiesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunitiesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'isNewCommercialRelation': json['isNewCommercialRelation'] == null ? undefined : json['isNewCommercialRelation'],
        'proposals': ((json['proposals'] as Array<any>).map(ProposalResourceFromJSON)),
        'projects': ((json['projects'] as Array<any>).map(ProjectResourceFromJSON)),
    };
}

export function OpportunitiesResourceToJSON(value?: OpportunitiesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isNewCommercialRelation': value['isNewCommercialRelation'],
        'proposals': ((value['proposals'] as Array<any>).map((v) => ProposalResourceToJSON(v))),
        'projects': ((value['projects'] as Array<any>).map((v) => ProjectResourceToJSON(v))),
    };
}

